import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { TextField, Toolbar } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@mui/material/Snackbar";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import { CheckCircleIcon } from "lucide-react";
import axios from "axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "30px",
};

export default function EmployeeModal() {
  const [open, setOpen] = React.useState(false);
  const [name, setName] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [confirm, setConfirm] = React.useState("");
  const [errors, setErrors] = React.useState({});
  const [snackbarState, setSnackbarState] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });

  const { vertical, horizontal, open: snackbarOpen } = snackbarState;

  // Open and close modal
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setErrors({});
  };

  // Validation check and form submission
  const handleClick = () => {
    const newErrors = {};

    // Validation rules
    if (!name) {
      newErrors.name = "Нэрээ оруулна уу";
    } else if (name.length < 4) {
      newErrors.name = "Нэр дор хаяж 4 тэмдэгт байх ёстой.";
    }

    if (!email) {
      newErrors.email = "Емайл хоосон байна";
    } else if (!email.includes("@")) {
      newErrors.email = "Емайлд '@' тэмдэг байх ёстой";
    } else if (email.length < 8) {
      newErrors.email = "Емайл дор хаяж 8 тэмдэгт байх ёстой";
    }

    if (!phone) {
      newErrors.phone = "Утасны дугаараа оруулна уу";
    } else if (phone.length < 8 || isNaN(phone)) {
      newErrors.phone = "Утасны дугаар зөвхөн 8 оронтой тоо байх ёстой";
    }

    if (!password) {
      newErrors.password = "Нууц үгээ оруулна уу";
    } else if (password.length < 6) {
      newErrors.password = "Нууц үг дор хаяж 6 тэмдэгт байх ёстой.";
    }

    if (password !== confirm) {
      newErrors.confirm = "Нууц үгүүд тохирохгүй байна";
    }

    // If no validation errors, submit the form
    if (Object.keys(newErrors).length === 0) {
      // alert('asdasd')
      axios
        .post("https://tsetsegtuw.templateapi.xyz/user/register", {
          name,
          password,
          role: "admin",
          email,
          phone,
        })
        .then(() => {
          setSnackbarState({ ...snackbarState, open: true });
          // setOpen(false); // Close modal after saving
          // setName("");
          // setEmail("");
          // setPhone("");
          // setPassword("");
          // setConfirm("");
          // setErrors({});
          window.location.reload(false);
        })
        .catch((e) => alert(e));
    } else {
      setErrors(newErrors); // Display validation errors
    }
  };

  // Close snackbar
  const handleSnackbarClose = () => {
    setSnackbarState({ ...snackbarState, open: false });
  };

  return (
    <Toolbar>
      <Button variant="contained" color="primary" onClick={handleOpen}>
        Ажилтан нэмэх
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <DialogTitle
            sx={{
              color: (theme) =>
                theme.palette.mode === "dark" ? "white" : "black",
            }}
          >
            Ажилтан нэмэх
            <IconButton onClick={handleClose} style={{ float: "right" }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Stack spacing={2} margin={2}>
              <TextField
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
                label="Нэр"
                error={Boolean(errors.name)}
                helperText={errors.name}
              />
              <TextField
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                label="Емайл"
                error={Boolean(errors.email)}
                helperText={errors.email}
              />
              <TextField
                variant="outlined"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                label="Утасны дугаар"
                error={Boolean(errors.phone)}
                helperText={errors.phone}
              />
              <TextField
                variant="outlined"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                label="Нууц үг"
                error={Boolean(errors.password)}
                helperText={errors.password}
              />
              <TextField
                variant="outlined"
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                label="Нууц үг давтах"
                error={Boolean(errors.confirm)}
                helperText={errors.confirm}
              />

              <Box display="flex" justifyContent="space-between">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleClick}
                >
                  Хадгалах
                </Button>
                <Button variant="contained" color="error" onClick={handleClose}>
                  Хаах
                </Button>
              </Box>
            </Stack>
          </DialogContent>
        </Box>
      </Modal>

      {/* Snackbar for notifications */}
      <Snackbar
        autoHideDuration={6000}
        anchorOrigin={{ vertical, horizontal }}
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        message={
          <span className="flex items-center text-green-500">
            <CheckCircleIcon className="mr-2" /> Амжилттай бүртгэлээ
          </span>
        }
      />
    </Toolbar>
  );
}
